<template>
  <UserAvatar
    class="tw:size-[30px]"
    :display-name="displayName"
    :image-url="imageUrl"
  />
</template>

<script setup>
import UserAvatar from '@/components/common/user-avatar.vue'

defineProps({
  imageUrl: {
    type: String,
    default: '',
  },
  displayName: {
    type: String,
    required: true,
  },
})
</script>
